export default __webpack_public_path__ + "static/media/camera-icon.ad999396.svg";